import { render, staticRenderFns } from "./ProspectDetails.vue?vue&type=template&id=74ac4220&scoped=true&"
import script from "./ProspectDetails.vue?vue&type=script&lang=ts&"
export * from "./ProspectDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac4220",
  null
  
)

export default component.exports